import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Tabs, Tab, Paper } from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import {
  obtenerExpedientePorId,
  updateExpediente,
  getRequisitos,
  obtenerSeguimiento,
  getUsersList,
  getUsersByExpedienteList,
  getUsuariosInternos,
  getDocumentosAprobadosPorExpediente
} from "../services/expediente.service";
import { obtenerOficinas } from "../services/oficinas.service";
import { obtenerTiposDeTramite } from "../services/tipoTramite.service";
import { obtenerSms } from "../services/sms.service";
import Modal from "../components/Modal";
import moment from "moment-timezone";
import "./Expediente.css";
import { USERID, DESTINOS } from "../config/constants";
import { notification } from "antd";
import { COLORS } from "../config/theme";
import ButtonComponent from "../components/ButtonComponent";
import { HistoricoMensajeriaTable } from "../components/HistoricoMensajeriaTable";
import { MensajesTable } from "../components/MensajesTable";
import { SeguimientoTable } from "../components/SeguimientoTable";
import { useAuth } from "../hooks";
import { obtenerAccesosPorUsuarioExpediente } from "../services/access.service";
import { ACCESOS } from "../config/constants";
import { createUploadFile } from "../services/uploadFile.service";
import ExpedienteFinalizar from "../components/ExpedienteFinalizar";
import DocumentosAprobados from "../components/DocumentosAprobados";
import ExpedienteDatosPrincipales from "../components/ExpedienteDatosPrincipales";

const AprobadoSello = ({ visible }) => {
  return visible ? (
    <div className="sello-aprobado">
      <span>Aprobado</span>
    </div>
  ) : null;
};

const RechazadoSello = ({ visible }) => {
  return visible ? (
    <div className="sello-rechazado">
      <span>Rechazado</span>
    </div>
  ) : null;
};

const Expediente = () => {
  const { id_expediente } = useParams();
  const { user } = useAuth();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const allowEditFinished = searchParams.get("forceEdit") === "1";

  const [procedureData, setProcedureData] = useState({
    id_estado: "",
    alta_fec: moment().format("YYYY-MM-DD"),
    fecha_oficina_actual: moment().format("YYYY-MM-DD"),
    id_tramite: "",
    id_oficina_actual: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [oficinasList, setOficinasList] = useState([]);
  const [tipoTramiteList, setTipoTramiteList] = useState([]);
  // const [usuarioOficina, setUsuarioOficina] = useState(null);
  const [requisitos, setRequisitos] = useState([]);
  const [smsList, setSmsList] = useState([]);
  const [mensajesList, setMensajesList] = useState([]);
  const [seguimientosList, setSeguimientosList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [messageUsersList, setMessagesUsersList] = useState([]);
  const [internalUsersList, setInternalUsersList] = useState([]);
  const [accesoCrearSms, setAccesoCrearSms] = useState(false);
  const [accesoSeguimientoMover, setAccesoSeguimientoMover] = useState(false);
  const [accesoCrearRequisito, setAccesoCrearRequisito] = useState(false);
  const [accesoOpcionalRequisito, setAccesoOpcionalRequisito] = useState(false);
  const [accesoEditarExpediente, setAccesoEditarExpediente] = useState(false);
  const [accesoCompletarRequisito, setAccesoCompletarRequisito] =
    useState(false);
  const [accesoEliminarRequisito, setAccesoEliminarRequisito] = useState(false);
  const [accesoVerificarRequisito, setAccesoVerificarRequisito] =
    useState(false);
  const [accesoRechazarRequisito, setAccesoRechazarRequisito] = useState(false);
  const [accesoHistorial, setAccesoHistorial] = useState(false);
  const [accesoPlantilla, setAccesoPlantilla] = useState(false); 
  const [accesoFinalizarTramite, setAccesoFinalizarTramite] = useState(false);
  const [requerimientosCompletos, setRequerimientosCompletos] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [estadosList, setEstadosList] = useState([
    { id: 1, nombre: "Pendiente" },
    { id: 2, nombre: "En revisión" },
    { id: 3, nombre: "Aprobado" },
    { id: 4, nombre: "Rechazado" },
    { id: 5, nombre: "Cancelado" },
  ]);

  const [destinosList, setDestinoslList] = useState(DESTINOS);
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);
  const [address, setAddress] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [reload, setReload] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [isAprobado, setIsAprobado] = useState(false);
  const [isRechazado, setIsRechazado] = useState(false);
  const [hasApprovedDocuments, setHasApprovedDocuments] = useState(false);
  const isFinalState = isAprobado || isRechazado;
  const isLocked = isFinalState && !allowEditFinished;

  // Crear una función para manejar los paneles de cada tab
  // const TabPanel = ({ children, value, index }) => {
  //   return value === index ? <Box p={3}>{children}</Box> : null;
  // };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    setProcedureData({
      id_estado: !id_expediente ? 1 : null,
      alta_fec: !id_expediente ? moment().format("YYYY-MM-DD") : null,
    });
    setInputValue("");
    loadOficinas();
    loadTiposDeTramite();
    loadUsers();
    loadRequisitos(id_expediente);
    loadSms(id_expediente);
    loadSeguimiento(id_expediente);
    loadAccesosPorUsuario(user.id_usuario, id_expediente);
    loadExpedientePorId(id_expediente);
    loadDocumentosAprobados(id_expediente);
  }, [id_expediente, reload]);

  const loadDocumentosAprobados = async (id_expediente) => {
    if (!id_expediente) {
      setHasApprovedDocuments(false);
      return;
    }
    try {
      const result = await getDocumentosAprobadosPorExpediente(id_expediente);
      setHasApprovedDocuments(Array.isArray(result.data) && result.data.length > 0);
    } catch (error) {
      console.log("error fetching documentos aprobados", error);
      setHasApprovedDocuments(false);
    }
  };

  const loadExpedientePorId = (id_expediente) => {
    obtenerExpedientePorId(id_expediente).then((results) => {
      const dataWithId = {
        ...results.data,
        id: results.data.id_expediente,
      };
      setProcedureData(dataWithId);

      setIsAprobado(dataWithId.id_estado === 3);
      setIsRechazado(dataWithId.id_estado === 4);

      // Si está finalizado, solo bloquea si NO viene el override por query param
      if ((dataWithId.id_estado === 3 || dataWithId.id_estado === 4) && !allowEditFinished) {
        setAccesoEditarExpediente(false);
      }

      if(results?.data?.dir_calle && results?.data?.dir_nro){
        setInputValue(results?.data?.dir_calle + " " + results?.data?.dir_nro);
      }else{
        setInputValue("");
      }

      setIsLoading(false);
    }).catch((err) => {
      notification["error"]({
        message: err.response.data.message,
      });
      navigate("/");
    });
  };

  const loadTiposDeTramite = () => {
    obtenerTiposDeTramite()
      .then((results) => {
        setTipoTramiteList(results.data);
      })
      .catch((error) => {
        console.log("Error obteniendo tipo de tramite", error);
      });
  };

  const loadOficinas = () => {
    obtenerOficinas().then((results) => {
      setOficinasList(results.data);
    });
  };

  const loadRequisitos = async (id_expediente) => {
    try {
      const result = await getRequisitos(id_expediente);

      if (result.data && result.data.length > 0) {
        setRequisitos(result.data);

        // Verificar si todos los elementos con opcionales === 0 tienen id_estado === 2
        const allOpcionalesCompleted = result.data.every((item) => {
          if (item.opcional === 0) {
            return item.id_estado === 2;
          }
          return true; // Si opcionales no es 0, no afecta la condición
        });
        // Si se cumple la condición, entonces marcar como completos
        if (allOpcionalesCompleted) {
          setRequerimientosCompletos(true);
        }
      }
    } catch (error) {
      console.log("error fetching requisitos", error);
    }
  };

  const loadUsers = async () => {
    try {
      const result = await getUsersList();
      const result2 = await getUsersByExpedienteList(user.id_usuario, id_expediente);
      const result3 = await getUsuariosInternos();

      if (result.data) {
        setUsersList(result.data);
      }
      if (result2.data) {
        setMessagesUsersList(result2.data);
      }
      if (result3.data) {
        setInternalUsersList(result3.data);
      }
    } catch (error) {
      console.log("error fetching users", error);
    }
  };

  const loadSms = async (id_expediente) => {
    try {
      const result = await obtenerSms(id_expediente);
      if (result.data?.data && result.data?.data?.length > 0) {
        // Ajustar las fechas al huso horario local (UTC-3)
        const adjustedData = result.data.data.map((item) => {
          const localDate = new Date(item.fecha_env);
          localDate.setHours(localDate.getHours() - 3); // Ajustar el huso horario a UTC-3
          return { ...item, fecha_env: localDate };
        });
  
        // Separar y ordenar los elementos
        const mensajesArr = adjustedData
          .filter((item) => item.conversa === 1)
          .sort((a, b) => new Date(b.fecha_env) - new Date(a.fecha_env)); // Ordenar por fecha_env descendente
  
        const smsArr = adjustedData
          .filter((item) => item.conversa !== 1)
          .sort((a, b) => new Date(b.fecha_env) - new Date(a.fecha_env)); // Ordenar por fecha_env descendente
  
        // Llamar a las funciones correspondientes
        setMensajesList(mensajesArr);
        setSmsList(smsArr);
      }
    } catch (error) {
      console.log("Error fetching requisitos", error);
    }
  };
  
  

  const loadSeguimiento = async (id_expediente) => {
    try {
      const results = await obtenerSeguimiento(id_expediente);
      console.log("Seguimiento", results?.data?.data);

      if (results.data && results?.data?.data?.length > 0) {
        setSeguimientosList(results?.data?.data);
      } else {
        console.log("No se encontraron datos de seguimiento.");
      }
    } catch (error) {
      console.error("Error fetching seguimiento", error);
    }
  };

  const loadAccesosPorUsuario = async (id_usuario, id_expediente) => {
    try {
      const results = await obtenerAccesosPorUsuarioExpediente(
        id_usuario,
        id_expediente
      );
      console.log("Accesos por usuario", results?.data?.data);

      if (results.data && results?.data?.data?.length > 0) {
        const accesos = results.data.data;
        setAccesoEditarExpediente(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.TRAMITE_MODIFICACION
          )
        );
        setAccesoCrearRequisito(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_AGREGAR
          )
        );
        setAccesoSeguimientoMover(
          accesos.some((acceso) => acceso.acceso === ACCESOS.SEGUIMIENTO_MOVER)
        );
        setAccesoCompletarRequisito(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_RESOLVER
          )
        );
        setAccesoRechazarRequisito(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_RECHAZAR
          )
        );
        setAccesoEliminarRequisito(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_ELIMINAR
          )
        );
        setAccesoOpcionalRequisito(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_OPCIONAL
          )
        );
        setAccesoCrearSms(
          accesos.some((acceso) => acceso.acceso === ACCESOS.SMS_CREAR)
        );
        setAccesoVerificarRequisito(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_VALIDAR
          )
        );
        setAccesoHistorial(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_HISTORIAL
          )
        );
        setAccesoPlantilla(
          accesos.some(
            (acceso) => acceso.acceso === ACCESOS.REQUERIMIENTO_PLANTILLA
          )
        );        
        setAccesoFinalizarTramite(
          accesos.some((acceso) => acceso.acceso === ACCESOS.TRAMITE_FINALIZAR)
        );
        console.log("Plantilla", accesoPlantilla);
      } else {
        console.log("No se encontraron datos de Accesos por usuario.");
      }
    } catch (error) {
      console.error("Error fetching Accesos por usuario", error);
    }
  };

  const handleInputChange = (event, name) => {
    const value = event.target ? event.target.value : event;
    setProcedureData({
      ...procedureData,
      [name]: value,
    });
  };

  const handleAddressChange = (event, name = "dir_calle") => {
    const value = event?.target?.value ?? event ?? "";
    setAddress(value);
    setInputValue(value); // ← sincroniza inputValue también
    setProcedureData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAutocompleteChange = (event, value, name) => {
    console.log("value change", value);
    console.log("name", name);
    setProcedureData({
      ...procedureData,
      [name]: value ? value.id : null,
    });
  };

  const handleMultipleAutocompleteChange = (e, value, field) => {
    // Convierte los valores seleccionados a una cadena separada por comas
    const concatenatedValues = value.map((item) => item.id).join(",");
  
    // Actualiza el estado para almacenar los valores seleccionados
    setProcedureData({
      ...procedureData,
      [field]: concatenatedValues, // Guarda los valores concatenados en el campo correspondiente
    });
  };
  

  const handleSubmit = async () => {
    if (id_expediente) {
      try {
        const updateResponse = await updateExpediente(
          id_expediente,
          procedureData
        );
        console.log("respuesta al updatear expediente:", updateResponse);
        if (updateResponse.data) {
          notification["success"]({
            message:
              updateResponse?.data?.message ||
              "Registro actualizado exitosamente",
          });

          navigate("/");
        }
      } catch (error) {
        console.log("error al updatear expediente", error);
        notification["error"]({
          message:
            error?.response?.data?.message ||
            "Error al actualizar el expediente",
        });
      }
    }
  };

  const handleFinishClick = () => {
    setModalTitle(`FINALIZAR EXPEDIENTE #${id_expediente}`);
    setModalContent(
      <ExpedienteFinalizar
        handleFinish={finalizarExpediente}
        setIsVisibleModal={setIsVisibleModal}
        setReload={setReload}
        reload={reload}
        isVisibleModal={isVisibleModal}
      />
    );
    setIsVisibleModal(true);
  };

  const addFiles = async (fileSelectedext) => {
    try {
      if (fileSelectedext.length > 0) {
        setIsLoading(true);
        await Promise.all(
          fileSelectedext.map(async (file) => {
            const result = await createUploadFile(
              file.file,
              id_expediente,
              null,
              3
            );

            if (result.status === 200) {
              return result;
            }
            return null;
          })
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Failed to add selection", error);
    }
  };

  const finalizarExpediente = (payload) => {
    addFiles(payload.files);
    updateExpediente(id_expediente, {
      id_estado: 3,
      obs_finalizado: payload.observation,
    });
    console.log(payload);
  };

  const cancel = () => {
    navigate("/");
  };

  useEffect(() => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps JavaScript API script not loaded");
      return;
    }

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["address"],
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place && place.geometry) {
        const address = place.formatted_address;
        const position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };

        setInputValue(address);

        const country = place.address_components.find((component) =>
          component.types.includes("country")
        );
        const locality = place.address_components.find((component) =>
          component.types.includes("locality")
        );
        const administrative_area_level_2 = place.address_components.find(
          (component) => component.types.includes("administrative_area_level_2")
        );
        const administrative_area_level_1 = place.address_components.find(
          (component) => component.types.includes("administrative_area_level_1")
        );
        const codePostal = place.address_components.find((component) =>
          component.types.includes("postal_code")
        );

        const addressNew = place.address_components.find((component) =>
          component.types.includes("route")
        );
        const numberAddress = place.address_components.find((component) =>
          component.types.includes("street_number")
        );

        const pais = country?.long_name || "";
        const localidad = locality?.long_name || "";
        const municipio = administrative_area_level_2?.long_name || "";
        const codigoPostal = codePostal?.long_name || "";
        const provincia = administrative_area_level_1?.long_name || "";
        const calle = addressNew?.long_name || "";
        const numero = numberAddress?.long_name || "";

        setProcedureData({
          ...procedureData,
          dir_calle: calle,
          dir_nro: numero,
          dir_loc: localidad,
          pais: pais,
          municipio: municipio,
          codigoPostal: codigoPostal,
          provincia: provincia,
          lat: position.lat,
          lng: position.lng,
        });
      }
    });

    autocompleteRef.current = autocomplete;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  useEffect(() => {
    // Find the selected tipoTramite
    const selectedTipoTramite = tipoTramiteList.find(
      (item) => item.id === parseInt(procedureData.id_tramite)
    );

    if (selectedTipoTramite) {
      setProcedureData((prevState) => ({
        ...prevState,
        id_oficina_actual: selectedTipoTramite.id_oficina_inicia,
      }));
    }
  }, [procedureData.id_tramite, tipoTramiteList]);

  // TRIGGER DE CAMBIO DE ESTADO
  useEffect(() => {
    debugger;
    setIsAprobado(procedureData.id_estado === 3);
    setIsRechazado(procedureData.id_estado === 4);
    // Si está finalizado y NO hay override, bloquea edición
    if ((procedureData.id_estado === 3 || procedureData.id_estado === 4) && !allowEditFinished) {
      setAccesoEditarExpediente(false);
    }
  }, [procedureData.id_estado, isAprobado, isRechazado, allowEditFinished]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="abmContainer">
          <h3>{`EXPEDIENTE #${id_expediente}`}</h3>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label="Datos principales" />
            {accesoCompletarRequisito && <Tab label="Notificaciones" />}
            {accesoCompletarRequisito && <Tab label="Mensajes" />}
            {accesoCompletarRequisito && <Tab label="Seguimiento" />}
            {hasApprovedDocuments && <Tab label="Documentos aprobados" />}
          </Tabs>
          <Box p={3} hidden={tabIndex !== 0}>
            {/* DATOS PRINCIPALES */}
            <ExpedienteDatosPrincipales
              tipoTramiteList={tipoTramiteList}
              procedureData={procedureData}
              handleAutocompleteChange={handleAutocompleteChange}
              handleMultipleAutocompleteChange={handleMultipleAutocompleteChange}
              handleInputChange={handleInputChange}
              handleAddressChange={handleAddressChange}
              inputValue={inputValue}
              inputRef={inputRef}
              destinosList={destinosList}
              estadosList={estadosList}
              requisitos={requisitos}
              setReload={setReload}
              usuario={user}
              reload={reload}
              id_expediente={id_expediente}
              accesoEditarExpediente={accesoEditarExpediente}
              accesoCrearRequisito={accesoCrearRequisito}
              accesoOpcionalRequisito={accesoOpcionalRequisito}
              accesoCompletarRequisito={accesoCompletarRequisito}
              accesoEliminarRequisito={accesoEliminarRequisito}
              accesoVerificarRequisito={accesoVerificarRequisito}
              accesoRechazarRequisito={accesoRechazarRequisito}
              accesoHistorial={accesoHistorial}
              accesoPlantilla={accesoPlantilla}
              oficinasList={oficinasList}
              isAprobado={isAprobado}
              isRechazado={isRechazado}
              isLocked={isLocked}
            />
          </Box>
          {/* NOTIFICACIONES */}
          <Box p={3} hidden={tabIndex !== 1}>
            {id_expediente && (
              <Grid container spacing={2} style={{ height: "70%" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginLeft: "1rem",
                    boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    borderRadius: "4px",
                    padding: "0.2rem",
                  }}
                >
                  <HistoricoMensajeriaTable
                    data={smsList || []}
                    setReload={setReload}
                    reload={reload}
                    id_expediente={id_expediente}
                    oficinasList={oficinasList}
                    usersList={messageUsersList}
                    internalUsersList={internalUsersList}
                    disabled={isLocked}
                    accionCrear={accesoCrearSms}
                  />
                </Grid>
              </Grid>
            )}
          </Box>
          {/* MENSAJES */}
          <Box p={3} hidden={tabIndex !== 2}>
            {id_expediente && (
              <Grid container spacing={2} style={{ height: "70%" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginLeft: "1rem",
                    boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    borderRadius: "4px",
                    padding: "0.2rem",
                  }}
                >
                  <MensajesTable
                    data={mensajesList || []}
                    setReload={setReload}
                    reload={reload}
                    id_expediente={id_expediente}
                    oficinasList={oficinasList}
                    usersList={messageUsersList}
                    internalUsersList={internalUsersList}
                    disabled={isLocked}
                    accionCrear={accesoCrearSms}
                  />
                </Grid>
              </Grid>
            )}
          </Box>          
          {/* SEGUIMIENTO */}
          <Box p={3} hidden={tabIndex !== 3}>
            {id_expediente && (
              <Grid container spacing={2} style={{ height: "70%" }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginLeft: "1rem",
                    boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                    border: "1px solid rgba(0, 0, 0, 0.1)",
                    borderRadius: "4px",
                    padding: "0.2rem",
                  }}
                >
                  <SeguimientoTable
                    data={seguimientosList || []}
                    setReload={setReload}
                    reload={reload}
                    disabled={isLocked}
                    accionMover={accesoSeguimientoMover}
                    oficinasList={oficinasList}
                  />
                </Grid>
              </Grid>
            )}
          </Box>
          {/* DOCUMENTOS APROBADOS */}
          <Box p={3} hidden={tabIndex !== 4}>
            {hasApprovedDocuments && (
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{
                  height: "60vh", // Ocupa todo el alto del viewport
                  width: "80vw", // Ocupa todo el ancho del viewport
                  padding: "1rem", // Espaciado interno opcional
                  boxSizing: "border-box", // Incluye el padding en el cálculo del ancho y alto total
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={12} // Ajusta según tus necesidades
                  lg={12} // Ajusta según tus necesidades
                  style={{
                    maxWidth: "100%", // Asegura que no se exceda el ancho del contenedor
                  }}
                >
                  <Paper
                    style={{
                      margin: "auto",
                      boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
                      border: "1px solid rgba(0, 0, 0, 0.1)",
                      borderRadius: "4px",
                      padding: "8rem",
                      textAlign: "center",
                    }}
                  >
                    <DocumentosAprobados idExpediente={id_expediente} />
                  </Paper>
                </Grid>
              </Grid>
            )}
          </Box>
          <Grid
            container
            spacing={1}
            style={{
              justifyContent: "flex-end",
            }}
          >
            <Grid
              item
              xs={12}
              xl={2}
              lg={2}
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              {requerimientosCompletos && accesoFinalizarTramite && (
                <ButtonComponent
                  name={"Finalizar trámite"}
                  color={COLORS.SUCCESS}
                  toAction={handleFinishClick}
                  disabled={isAprobado || isRechazado}
                />
              )}
              {accesoEditarExpediente && (
                <ButtonComponent
                  name={"Guardar"}
                  color={COLORS.SECONDARY}
                  toAction={handleSubmit}
                  disabled={isLocked}
                />
              )}

              <ButtonComponent
                name={"Cancelar"}
                color={COLORS.DANGER}
                toAction={cancel}
                disabled={isLocked}
              />
            </Grid>
          </Grid>
          <AprobadoSello
            visible={isAprobado && tabIndex === 0 && isVisibleModal === false && isLocked}
          />
          <RechazadoSello
            visible={isRechazado && tabIndex === 0 && isVisibleModal === false}
          />
        </div>
      )}
      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default Expediente;
